// apps/share-web/src/chart/chart-escape.ts
//
// Escape для поверхностей чарта. Один модуль на две поверхности, потому что
// правило одно, а поверхностей две — панель и полный экран.
//
// Так делают соседи: ui/share-modal.ts, ui/promo-modal.ts, ui/app-header.ts,
// ui/feedback-modal.ts и ui/section-handlers.ts каждый слушает Escape на
// `document` и решает по своему состоянию, его ли это клавиша. У чарта этого не
// было вовсе, и на ноутбуке единственным выходом из полноэкранного чтения
// оставался клик по крестику.
//
// ФАЗА ПЕРЕХВАТА и остановка распространения — не аккуратность, а необходимость.
// `ui/section-handlers.ts` живёт ВНУТРИ той же поверхности плеера (его монтирует
// waves.ts) и по Escape на `document` СНИМАЕТ петлю секции. Один Escape не должен
// делать два дела: закрывать чтение и заодно снимать петлю, которую читатель
// поставил сам. Перехват на `document` исполняется до всплытия на нём же, поэтому
// остановка распространения гасит соседа — а когда закрывать нечего, мы
// распространение не трогаем и петля снимается как раньше.
//
// `stopImmediatePropagation` здесь НЕ подходит: он гасил бы и слушателей на том
// же узле, то есть панель (её слушатель зарегистрирован раньше) отбирала бы
// клавишу у слоя, открытого над ней. Порядок «верхняя поверхность забирает
// Escape» держится не порядком регистрации, а предикатом `active`.

/**
 * Подписывает закрытие по Escape и возвращает отписку.
 *
 * @param active «эта клавиша моя» — поверхность открыта И над ней ничего нет.
 *   Ложь означает полное невмешательство: ни закрытия, ни остановки клавиши.
 * @param close что делать по Escape.
 */
export function bindEscape(active: () => boolean, close: () => void): () => void {
  const onKey = (e: KeyboardEvent): void => {
    if (e.key !== 'Escape') return;
    if (!active()) return;
    e.stopPropagation();
    close();
  };
  document.addEventListener('keydown', onKey, true);
  return () => { document.removeEventListener('keydown', onKey, true); };
}
